import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders, HttpRequest } from '@angular/common/http';
import { catchError, map, tap } from 'rxjs/operators';
import { QuantityUomModel } from '../models/quantityuom';
import { ConfigurationSettings } from '../configuration-settings';

@Injectable()
export class QuantityUomService {
    url = ConfigurationSettings.REST_API_URL + '/api/quantityuom';
    httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };

    constructor(private _http: HttpClient) { }

    public getQuantityUoms(): any {
       
        return this._http.get(this.url).pipe(
            tap(x => console.log('Fetched quantity uoms')));
    }

    public updateQuantityUom(ft: QuantityUomModel): any {
        let body = JSON.stringify(ft);
        return this._http.put(
            this.url,
            body, this.httpOptions).pipe(
                tap(x => console.log('Updated quantityuom'))
            );
    }
    public createQuantityUom(ft: QuantityUomModel): any {
        let body = JSON.stringify(ft);
        return this._http.post(
            this.url,
            body, this.httpOptions).pipe(
                tap(x => console.log('quantityuom created'))
            );
    }

    public checkDuplicate(ft: QuantityUomModel): any {
        let body = JSON.stringify(ft);
        return this._http.get(this.url +"/CheckDuplicate?UOMDisplay="+ft.uomDisplay).pipe(
            tap(x => console.log('Check duplicate uoms')));
    }

}